module.exports = __webpack_public_path__ + "static/confirm-offer-f14cb01eaf3fd2471b105dde266ef303.png";